import { isAxiosError } from 'axios';

/**
 * `responseType: 'blob'` 요청은 실패 본문도 Blob 으로 온다. 그대로 두면 오류 문구도, 키오스크
 * 오류 `code` 도 읽을 수 없으므로 JSON 이면 풀어서 `response.data` 에 다시 넣고 던진다.
 */
export const withJsonErrorBody = async <T>(request: Promise<T>): Promise<T> => {
  try {
    return await request;
  } catch (error) {
    const data = isAxiosError(error) ? error.response?.data : undefined;
    if (isAxiosError(error) && error.response && data instanceof Blob) {
      try {
        error.response.data = JSON.parse(await data.text());
      } catch {
        // JSON 이 아니면 원래 Blob 을 둔다
      }
    }
    throw error;
  }
};
